<div mat-dialog-content class="generate-container row">
  <app-product-search [modalView]="modalMode" [fundData]="fundData" />
</div>
<mat-dialog-actions class="row buttons">
  <button type="button" mat-raised-button class="close" (click)="cancel()">
    Cancel
  </button>
</mat-dialog-actions>
<ngx-loading [show]="loading" />
